<script setup lang="ts">
defineOptions({
  name: 'AppBootSkeleton',
})

const bootSkeletonCards = [
  '10 / 16',
  '3 / 4',
  '16 / 10',
  '3 / 4',
  '10 / 16',
  '16 / 10',
  '3 / 4',
  '10 / 16',
  '16 / 10',
  '3 / 4',
  '10 / 16',
  '16 / 10',
] as const
</script>

<template>
  <div class="boot-shell" aria-hidden="true">
    <aside class="boot-sidebar">
      <span class="boot-logo"></span>
      <span class="boot-nav">
        <span class="boot-nav-line"></span>
        <span class="boot-nav-line"></span>
        <span class="boot-nav-line"></span>
        <span class="boot-nav-line"></span>
        <span class="boot-nav-line"></span>
        <span class="boot-nav-line"></span>
      </span>
    </aside>
    <main class="boot-main">
      <section class="boot-grid">
        <article
          v-for="(aspectRatio, index) in bootSkeletonCards"
          :key="`${aspectRatio}-${index}`"
          class="boot-card"
        >
          <div class="boot-media" :style="{ '--boot-aspect': aspectRatio }"></div>
          <div class="boot-copy"></div>
          <div class="boot-author"></div>
        </article>
      </section>
    </main>
  </div>
</template>
